import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getFonts,
  getFontsFiltered,
  deleteFontById,
  insertFont,
  updateFont,
  getFontById,
  updateOrderFont,
  generateFonts,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FONTS(action) {
  try {
    const fontsData = yield call(getFonts, action.payload)
    if (fontsData.ok) {
      yield put({
        type: actions.FONTS_LOAD_SUCCEEDED,
        payload: fontsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Fonts')
      put({
        type: actions.FONTS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FONTS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FONTS_FILTERED(action) {
  try {
    const fontsData = yield call(getFontsFiltered, action.payload)
    if (fontsData.ok) {
      yield put({
        type: actions.FONTS_FILTERED_LOAD_SUCCEEDED,
        payload: fontsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Fonts')
      put({
        type: actions.FONTS_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FONTS_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FONT_BY_ID(action) {
  try {
    const dataResult = yield call(getFontById, action.payload)
    if (dataResult.ok) {
      yield put({
        type: actions.FONT_BYID_LOAD_SUCCEEDED,
        payload: dataResult.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la fuente')
      put({
        type: actions.FONT_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FONT_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FONTS_BY_ID(action) {
  try {
    const dataResult = yield call(deleteFontById, action.payload)
    if (dataResult.ok) {
      putMessage(messageType.SUCCESS, 'Fuente eliminado correctamente')
      yield put({
        type: actions.FONTS_DELETED_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la fuente')
      yield put({
        type: actions.FONTS_DELETED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la fuente')
    yield all([
      put({
        type: actions.FONTS_DELETED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GENERATE_FONTS(action) {
  try {
    const dataResult = yield call(generateFonts, action.payload)
    if (dataResult.ok) {
      putMessage(messageType.SUCCESS, 'Fichero de fuente generado correctamente')
      yield put({
        type: actions.FONTS_GENERATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al generar el fichero de fuentea')
      yield put({
        type: actions.FONTS_GENERATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al generar el fichero de fuentea')
    yield all([
      put({
        type: actions.FONTS_GENERATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FONTS(action) {
  try {
    const dataResult = yield call(insertFont, action.payload)    
    if (dataResult.ok) {
      putMessage(messageType.SUCCESS, 'Fuente creada correctamente')
      yield put({
        type: actions.FONTS_INSERTERED_SUCCEEDED,
        payload: dataResult.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear la fuente')
      yield put({
        type: actions.FONTS_INSERTERED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear la fuente')
    yield all([
      put({
        type: actions.FONTS_INSERTERED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FONTS(action) {
  try {
    const dataResult = yield call(updateFont, action.payload)    
    if (dataResult.ok) {
      putMessage(messageType.SUCCESS, 'Fuente modificada correctamente')
      yield put({
        type: actions.FONTS_UPDATED_SUCCEEDED,
        payload: dataResult.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar la fuente')
      yield put({
        type: actions.FONTS_UPDATED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar la fuente')
    yield all([
      put({
        type: actions.FONTS_UPDATED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ORDER_FONTS(action) {
  try {
    const dataResult = yield call(updateOrderFont, action.payload)
    if (dataResult.ok) {
      putMessage(messageType.SUCCESS, 'Orden de la fuente modificada correctamente')
      yield put({
        type: actions.FONTS_UPDATED_ORDER_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el orden de la fuente')
      yield put({
        type: actions.FONTS_UPDATED_ORDER_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el orden de la fuente')
    yield all([
      put({
        type: actions.FONTS_UPDATED_ORDER_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FONTS_LOAD_REQUESTED, GET_FONTS),
    takeEvery(actions.FONTS_FILTERED_LOAD_REQUESTED, GET_FONTS_FILTERED),
    takeEvery(actions.FONTS_DELETED_REQUESTED, DELETE_FONTS_BY_ID),
    takeEvery(actions.FONTS_INSERTERED_REQUESTED, INSERT_FONTS),
    takeEvery(actions.FONTS_UPDATED_REQUESTED, UPDATE_FONTS),
    takeEvery(actions.FONT_BYID_LOAD_REQUESTED, GET_FONT_BY_ID),
    takeEvery(actions.FONTS_UPDATED_ORDER_REQUESTED, UPDATE_ORDER_FONTS),
    takeEvery(actions.FONTS_GENERATE_REQUESTED, GENERATE_FONTS),
  ])
}
